export const COPY = {
  header: "Great! You're all done!",
  body: 'Once we confirm the quote details with Ideal4Finance, they will send you a link to apply for finance. Keep an eye our for their email!',
  subbody:
    "You can continue to use our calculator below to investigate how much you'd pay if you do take finance with Ideal4Finance",
};
